import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { Permissions } from 'src/app/shared/models/permissions.model';

@Component({
  selector: 'mobile-dropdown',
  templateUrl: './mobile-dropdown.component.html'
})
export class MobileDropdownComponent {

  @Input() displayMobileDropdown: boolean;

  @Output() hideMobileDropdown: EventEmitter<any> = new EventEmitter();

  public permissions: Permissions;
  public canViewLoans = true;
  public canViewReports = true;
  public canViewMyProfile = true;
  public canViewAdmin = true;
  public canCRUDMasterAdmin: boolean;

  constructor(private permissionService: PermissionService) {
    this.permissionService.permissions$.subscribe((permissions: Permissions) => {
      if (permissions) {
        this.permissions = permissions;
        this.setPermissions();
      }
    });
  }

  setPermissions() {
    this.canViewLoans = this.permissions.canViewLoans;
    this.canViewReports = this.permissions.canViewReports;
    this.canViewMyProfile = this.permissions.canViewProfile;
    this.canViewAdmin = false;
    this.canCRUDMasterAdmin = this.permissions.canCRUDMasterAdmin;
  }

  public onHideMobileDropdown() {
    this.hideMobileDropdown.emit();
  }
}
